import * as React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import Footer from '../../components/footer/Footer';
import HeaderLoggedOut from '../../components/headerLoggedOut/HeaderLoggedOut';
import './NewPasswordSuccess.css';

export default class NewPasswordSuccess extends React.PureComponent {
    public render() {
        return (
            <>
                <HeaderLoggedOut />
                <Container id="newPasswordSuccessView" className="text-center">
                    <Row>
                        <Col>
                            <h3>{TR.newPasswordSuccess_success}</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="offset-md-3">
                            {TR.newPasswordSuccess_saved}
                            <br />
                            <Link className="btn mt-3" to="/">
                                {TR.newPasswordSuccess_to_login}
                            </Link>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/newPasswordSucces/NewPasswordSuccess.tsx